(function () {

    var EVerifyComponent = {
        bindings: {
            everifyData: '<',
            hasRequestedDoc: '<',
            onClose: '<'
        },
        controller: ['$scope', '$compile', '$q', 'Upload', 'onBoardingService', '$filter', function ($scope, $compile, $q, Upload, onBoardingService, $filter) {

            var self = this;
            var component;
            var body = $('body');
            var modal = $('<div class="modal e-verify-modal" id="start-e-verify-modal"></div>');

            self.openDuplicateModal = function (data) {
                angular.extend(self.everifyData, data);

                if (component) {
                    component.remove();
                }

                component = $compile('<duplicate-cases everify-utils="$ctrl.EVerifyUtils" modal-data="$ctrl.everifyData" hide="$ctrl.hide(statusCode, data, i9NewDoc)"></duplicate-cases>')($scope);

                modal.removeClass('start-e-verify-modal');
                modal.addClass('cases-statuses');
                modal.append($(component));
            };

            // hide the e-verify modal
            self.hide = function (code, data, i9NewDoc) {
                data = data || {};

                switch (code) {
                    case "SUCCESS":
                    case "HIDE":
                        data['application_id'] = self.everifyData.application_id;
                        data['brand_id'] = self.everifyData.brand.id;
                        data['prospect_id'] = self.everifyData.prospect_id;
                        data['user_id'] = self.everifyData.user.id;
                        data['user'] = self.everifyData.user;
                        data['brand'] = self.everifyData.brand;
                        break;
                }

                self.onClose(data, code, i9NewDoc);
                modal.modal('hide');
            };

            // utils used by all components on the EVerify
            self.EVerifyUtils = new (function () {
                var self = this;

                // private utils functions
                var _formValidation = function (scope, className) {
                    var self = this;
                    var _protected = BaseForm.call(self, className, scope);
                };

                self.handleEVerifyErrorMessages = function (err, callback) {
                    if (typeof (err) !== 'object' && !Array.isArray(err.errors)) {
                        throw 'Please provide an error so we can show you what happen but here is the error: ' + err;
                    }
                    var errorTitle = 'Something went wrong on E-verify’s side';
                    var errorBody = '<p>Something went wrong on E-verify’s side</p>';
                    let button = $filter("translate")('Okay');
                    if (err && err.error){
                        for (var j = 0; j < err.error.length; j++) {
                            if (err.error.length === 1) {
                                errorBody += '<div>' + '"' + err.error[0].message + '"' + '</div>';
                            } else {
                                errorBody += '<div>' + 'Error ' + (j + 1) + ': "' + [err.error[j].message] + '"' + '</div>' + '<br>';
                            }
                        }
                    } else if (err && err.errors && err.errors[0] && err.errors[0].detail) {
                        if (err.errors[0].code === 'EVERIFY_TIMEOUT_EXCEPTION') {
                            errorTitle = $filter("translate")("E-verify is down");
                            button = $filter("translate")("Okay");
                            const errorMessage = $filter("translate")("It looks like E-verify is down. Try again in an hour.");

                            errorBody = `<div>"${errorMessage}"</div>`;
                        } else {
                            const errorDetail = err.errors[0].detail.errors && err.errors[0].detail.errors[0] && err.errors[0].detail.errors[0].message;
                            const errorMessage = errorDetail ? errorDetail: err.errors[0].detail;
                            errorBody += `<div>"${errorMessage}"</div>`;
                        }
                    }  else {
                        errorBody += '<div>' + err.data.data + '</div>';
                    }

                    hAlert({
                        title: errorTitle,
                        text: errorBody,
                        custom_class: 'vis-error-alert',
                        button: {text: button},
                    }, function () {
                        callback();
                    });
                };

                // return new form validation so you can use it on validation
                self.getFormValidation = function (scope, className) {
                    return new _formValidation(scope, className);
                };

                self.uploadI9Documents = function (document, file) {
                    var i9Utils = new I9EmployerForm(null, $q, Upload, null, null, null, true, onBoardingService);
                    return i9Utils.uploadAttachment(file, { document: document });
                };
            });

            self.changeStatusToResubmitEVerify = function () {

                if (component) {
                    component.remove();
                }

                component = $compile('<start-e-verify class="start-e-verify-modal" everify-utils="$ctrl.EVerifyUtils" check-duplicate="$ctrl.openDuplicateModal(data)" hide="$ctrl.hide(statusCode, data, i9NewDoc)" modal-data="$ctrl.everifyData"></start-e-verify>')($scope);

                modal.removeClass('cases-statuses');
                modal.addClass('start-e-verify-modal');
                modal.append($(component));
            };

            // this to init the e-verify modal
            self.$onInit = function () {

                self.everifyData = self.everifyData || {};
                self.everifyData.everify_case = self.everifyData.everify_case || {};
                self.everifyData.brand =  self.everifyData.brand || {};

                if (Object.keys(self.everifyData.brand).length === 0) {
                    throw 'E-Verify can not shows without brand';
                }

                if (Object.keys(self.everifyData.everify_case).length === 0 && self.everifyData.brand.isDoneEVerifyTest) {
                    throw 'E-Verify case not send and there is some data not found to continue this component please make sure to send the needed data';
                }

                if (!self.everifyData.everify_case.id && self.everifyData.brand.isDoneEVerifyTest) {
                    throw 'E-Verify modal need the case id to continue processing';
                }

                if (self.everifyData.everify_case.status === EVerifyAPI.STATUSES.CANCELLED && self.everifyData.brand.isDoneEVerifyTest) {
                    throw 'you can not start the E-Verify when the case is cancelled you need to resend the i9 again please';
                }

                var modalClass = '';

                if (component) {
                    component.remove();
                }

                var blockShow;

                if (
                    self.everifyData.everify_case.status === EVerifyAPI.STATUSES.NOT_STARTED &&
                    self.everifyData.employee_terminated
                ) {
                    blockShow = true;

                    hAlert(
                        'Not able to start E-verify',
                        'You will not be able to start e-verify as this employee has been terminated.',
                        null,
                        'vis-error-alert'
                    );
                } else if (
                    self.everifyData.everify_case.status === EVerifyAPI.STATUSES.NOT_STARTED &&
                    self.everifyData.document &&
                    self.everifyData.document.id !== self.everifyData.everify_case.document_id &&
                    self.hasRequestedDoc
                ) {
                    blockShow = true;
                    hAlert(
                        'Not able to start E-verify',
                        'You will not be able to start e-verify as you have sent a new I-9 and it is pending employee confirmation or employer e-sign.',
                        null,
                        'vis-error-alert'
                    );
                } else if (!self.everifyData.brand.isDoneEVerifyTest) {
                    component = $compile('<knowledge-test-certified-process hide="$ctrl.hide(statusCode, data, i9NewDoc)"></knowledge-test-certified-process>')($scope);
                } else if (
                    self.everifyData.everify_case.status &&
                    self.everifyData.everify_case.status !== EVerifyAPI.STATUSES.NOT_STARTED
                ) {
                    modalClass = 'cases-statuses';
                    component = $compile('<cases-statuses check-duplicate="$ctrl.openDuplicateModal(data)" on-resubmit="$ctrl.changeStatusToResubmitEVerify()" everify-utils="$ctrl.EVerifyUtils" modal-data="$ctrl.everifyData" hide="$ctrl.hide(statusCode, data, i9NewDoc)"></cases-statuses>')($scope);
                } else {
                    modalClass = 'start-e-verify-modal';
                    component = $compile('<start-e-verify class="start-e-verify-modal" everify-utils="$ctrl.EVerifyUtils" check-duplicate="$ctrl.openDuplicateModal(data)" hide="$ctrl.hide(statusCode, data, i9NewDoc)" modal-data="$ctrl.everifyData"></start-e-verify>')($scope);
                }

                if (!blockShow) {
                    modal.addClass(modalClass);
                    modal.append($(component));
                    body.append(modal);

                    modal.modal({
                        show: true,
                        keyboard: false,
                        backdrop: 'static'
                    });

                    modal.on('hidden.bs.modal', function(e) {

                        if (!e.target.classList.contains('e-verify-modal')) {
                            return;
                        }

                        // We need this because we call the digest cycle on the jQuery hidden event so we have to check
                        // if the cycle done digest or still
                        // if the cycle still digest we need just to call the function
                        var safeApply = function(scope, fn) {
                            var root = scope.$root || {};
                            var phase = root.$$phase;

                            if(phase === '$apply' || phase === '$digest') {
                                if(fn && (typeof(fn) === 'function')) {
                                    fn();
                                }
                            } else {
                                scope.$apply(fn);
                            }
                        };

                        safeApply($scope, function () {
                            modal.remove();
                        });
                    });
                }
            };

            // on destroy
            self.$onDestroy = function () {
                modal.remove();
            };
        }]
    };

    var InitEVerifyComponent = {
        bindings: {
            everifyData: '<',
            onClose: '<',
            showIconStatus: '<',
            showModal: '=',
            hasRequestedDoc: '=',
            inlineDisplay: '<'
        },
        transclude: true,
        controllerAs: 'initEVerify',
        templateUrl: '../modules/e-verify/e-verify.html',
        controller: ['$scope', '$timeout', 'brandServices', function ($scope, $timeout, brandServices) {
            var self = this;

            self.$onInit = function () {
                var brandId = self.everifyData.brand.id;

                brandServices.check(brandServices.SERVICES.E_VERIFY, brandId)
                    .then(function (isEverifyServiceEnabled) {
                        self.isEVerifyServiceEnabled = isEverifyServiceEnabled;

                        if (!self.isEVerifyServiceEnabled) {
                            throw 'You need the E-Verify service! please make sure you have this service on your brand';
                        }

                        self.everifyCase = self.everifyData.everify_case;
                        var application_id = self.everifyData.application_id;
                        var prospect_id = self.everifyData.prospect_id;

                        self.STATUSES = EVerifyAPI.STATUSES;
                        self.STATUSES_TEXT = EVerifyAPI.STATUSES_TEXT;

                        self.loadingI9 = true;

                        // load last i0 for this candidate every logic on the e-verify modal built on this
                        OnBoardingAPI.listDocuments(application_id, prospect_id, 'ON_BOARDING', null, true, null, OnBoardingAPI.DOCUMENT_TYPE.I9)
                            .then(function (docList) {
                                self.everifyData.document = docList[0] && docList[0].Document;

                                self.everifyData.i9DocumentSet = {
                                    DocumentSet: docList[0] && docList[0].DocumentSet,
                                    code: OnBoardingAPI.DOCUMENT_TYPE.I9,
                                    name: OnBoardingAPI.DOC_TYPE_TEXT.I9,
                                    type: "DOCUMENT"
                                };

                                $timeout(function () {
                                    self.loadingI9 = false;
                                });
                            }, function (err) {
                                throw err;
                            });

                        // Starting point for every actions on the e-verify
                        self.eVerifying = function () {
                            self.showModal = false;

                            $timeout(function () {
                                self.showModal = true;
                            }, 100);
                        }
                    });
            };

        }]
    };

    angular.module('harriApp.eVerify', [])
        .component('initEVerify', InitEVerifyComponent)
        .component('eVerify', EVerifyComponent);
})();
